import React from 'react';
export function FooterLogo() {
  return <div className="w-full flex items-center justify-center py-10" data-id="element-186">
      <img src="https://cdn.magicpatterns.com/patterns/figma-images/66g1a0V3VBLDEJqj7q2Lq0/4161-2159.png" alt="MaleUp Logo" style={{
      width: 268,
      height: 85
    }} data-id="element-187" />
    </div>;
}